import React from "react";
import ProductSelectableList from "./ProductSelectableList";

const ProductDashboardList = ({
    products,
    status,
    error,
    selectedProductId,
    selectedItemRef,
    onRetry,
    onSelect,
    onCampaignBadgeClick,
    onCampaignBadgeIntent,
    sequenceCountById,
    sequenceCountStatusById,
    sequenceCountErrorById,
}) => {
    return (
        <aside className="flex h-[36rem] min-h-0 min-w-0 flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm lg:h-full">
            <div className="shrink-0 border-b border-indigo-100 bg-[#eef2ff] p-4">
                <h2 className="text-lg font-semibold text-[#0f172a]">
                    Product List
                </h2>
                <p className="mt-1 text-sm text-[#475569]">
                    Select a product to review or update it.
                </p>
            </div>

            <div className="product-scrollbar min-h-0 flex-1 overflow-y-auto">
                <ProductSelectableList
                    products={products}
                    status={status}
                    error={error}
                    selectedProductId={selectedProductId}
                    selectedItemRef={selectedItemRef}
                    onRetry={onRetry}
                    onSelect={onSelect}
                    onCampaignBadgeClick={onCampaignBadgeClick}
                    onCampaignBadgeIntent={onCampaignBadgeIntent}
                    sequenceCountById={sequenceCountById}
                    sequenceCountStatusById={sequenceCountStatusById}
                    sequenceCountErrorById={sequenceCountErrorById}
                    variant="rows"
                    centerEmptyState
                />
            </div>
        </aside>
    );
};

export default ProductDashboardList;
